import { Link } from "react-router-dom";

const exploreLinks = [
  { to: "/", label: "首页" },
  { to: "/topics", label: "话题榜" },
  { to: "/discussion", label: "讨论区" },
  { to: "/faq", label: "常见问题" },
];

const categoryLinks = [
  { to: "/topics?category=variety", label: "综艺" },
  { to: "/topics?category=film", label: "影视" },
  { to: "/topics?category=music", label: "音乐" },
  { to: "/topics?category=concert", label: "演出" },
  { to: "/topics?category=industry", label: "行业观察" },
];

const aboutLinks = [
  { to: "/about", label: "关于我们" },
  { to: "/about#principles", label: "内容原则" },
  { to: "/about#contact", label: "联系我们" },
];

export default function Footer() {
  return (
    <footer className="bg-accent-900 text-accent-50 mt-16 md:mt-24">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500 text-background-50 font-display text-xl">
                瓜
              </span>
              <span className="font-display text-2xl">瓜田吃瓜</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-accent-100/85 max-w-sm">
              把热门话题、事件脉络和不同立场的观点集中在一起，让你一次吃透一个瓜，而不是被碎片信息带着跑。
            </p>
            <a
              href="mailto:hello@guatianchigua.cn"
              className="mt-5 inline-flex items-center gap-2 text-sm text-accent-100 hover:text-background-50 transition-colors"
            >
              <i className="ri-mail-line w-4 h-4 flex items-center justify-center" />
              hello@guatianchigua.cn
            </a>
          </div>

          <div id="footer-nav">
            <h4 className="text-sm font-medium tracking-wider text-background-50">
              <a href="#footer-nav" className="hover:text-primary-200 transition-colors">
                逛一逛
              </a>
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {exploreLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-accent-100/85 hover:text-background-50 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div id="footer-cats">
            <h4 className="text-sm font-medium tracking-wider text-background-50">
              <a href="#footer-cats" className="hover:text-primary-200 transition-colors">
                内容分类
              </a>
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {categoryLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-accent-100/85 hover:text-background-50 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div id="footer-about">
            <h4 className="text-sm font-medium tracking-wider text-background-50">
              <a href="#footer-about" className="hover:text-primary-200 transition-colors">
                关于与帮助
              </a>
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {aboutLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-accent-100/85 hover:text-background-50 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <a
                  href="mailto:hello@guatianchigua.cn"
                  rel="nofollow"
                  className="text-sm text-accent-100/85 hover:text-background-50 transition-colors"
                >
                  内容纠错
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 md:mt-14 pt-6 border-t border-accent-800/70 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <p className="text-xs text-accent-200/75">
            © 2026 瓜田吃瓜 · 站内内容为话题整理与网友观点汇总，仅供参考与讨论。
          </p>
          <div className="flex items-center gap-4 text-xs text-accent-200/75">
            <span>观点交锋，对事不对人</span>
            <span className="hidden sm:inline w-1 h-1 rounded-full bg-accent-600" />
            <span>理性围观</span>
          </div>
        </div>
      </div>
    </footer>
  );
}